import { render, staticRenderFns } from "./QuizSlideContent.vue?vue&type=template&id=3bb29ac4&scoped=true&"
import script from "./QuizSlideContent.vue?vue&type=script&lang=js&"
export * from "./QuizSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./QuizSlideContent.vue?vue&type=style&index=0&id=3bb29ac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb29ac4",
  null
  
)

export default component.exports